import "./App.css";
// import About from "./components/About";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";
import React, { useState } from "react";
import Alert from "./components/Alert";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  // const [mode, setMode] = useState('light');
  const [mode, setMode] = useState("light");
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 1000);
  };

  
  const toggleMode = () => {
    if (mode === "light") {
      setMode("dark");
      document.body.style.backgroundColor = "rgb(33 37 41)";
      showAlert("Dark Mode enabled", "success");
      
      // document.title = "TextUtils - Dark Mode enabled";
      // Chamakta Title logic
      // setInterval(() => {
      //   document.title = "TextUtils is BEST UTILITY";

      // }, 1500);
      // setInterval(() => {
      //   document.title = "INSTALL TextUtils";

      // }, 1000);
    } 

    else {
      setMode("light");
      document.body.style.backgroundColor = "white";
      showAlert("Light Mode enabled", "success");
      // document.title = "TextUtils - Light Mode enabled";
    }
  };



  return (
    <>
      {/* BELOW CODE IS WITH ROUTING */}
      
      {/* <Router> */}
      {/* <Navbar title = "TextUtils" aboutText = "About"/> */}
      {/* <Navbar
          title="TextUtils"
          mode={mode}
          toggleMode={toggleMode}
          greyColor={greyColor}
          greenColor={greenColor}
          redColor={redColor}
          yellowColor={yellowColor}
          cyanColor={cyanColor}
          resetToggleMode={resetToggleMode}
        />
        <Alert alert={alert} />
        <div className="container my-3">
          <Routes>
            <Route exact path="/about" element={<About />} />

            <Route
              exact
              path="/"
              element={
                <TextForm
                  heading="Enter the text to analyze below"
                  mode={mode}
                  showAlert={showAlert}/>
              }
            />
          </Routes>
        </div>
      </Router> */}
      
      {/* BELOW CODE IS WITHOUT ROUTING */}

      <Navbar
        title="TextUtils"
        mode={mode}
        toggleMode={toggleMode}
      />
      <Alert alert={alert} />
      <div className="container my-3">
        <TextForm
          heading="Try Textutils - Word & character counter, Remove extra spaces"
          mode={mode}
          showAlert={showAlert}
        />
      </div>
    </>
  );
}

export default App;
